import React from 'react'
import {
  func,
  string,
  arrayOf,
  object,
  oneOfType,
  instanceOf,
} from 'prop-types'
import { Route } from 'react-router-dom'
import { createUrl } from './util'
import Session from './Session'
import { ACCESS_DENIED } from './constants'

// Need to use Render component or we'll get the following warning:
// Warning: Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.
const Render = props => {
  const {
    allowed,
    component: Component,
    onUnauthenticated,
    onUnauthorized,
    unauthenticatedRoute,
    unauthorizedRoute,
    session,
    render: renderProp,
  } = props
  const onUnauthenticatedProvided = typeof onUnauthenticated === 'function'
  const authenticated =
    session && session instanceof Session && session.isAuthenticated()
  if (!authenticated && onUnauthenticatedProvided) {
    onUnauthenticated({ redirect: window.location.href })
  }
  const onUnauthorizedProvided = typeof onUnauthorized === 'function'
  const authorized = authenticated && session.isAuthorized(allowed)
  if (authenticated && !authorized && onUnauthorizedProvided) {
    onUnauthorized({
      redirect: window.location.href,
    })
  }
  //first check whether user is authenticated?
  return authenticated ? (
    //next check if they are authorized
    authorized ? (
      renderProp !== undefined && typeof renderProp === 'function' ? (
        renderProp(props)
      ) : (
        <Component {...props} />
      )
    ) : (
      <>
        {/* send them packing if they are not authorized */}
        {onUnauthorizedProvided ||
          window.location.replace(createUrl(unauthorizedRoute))}
      </>
    )
  ) : (
    // challenge the user if we are using fullPageAuth, else redirect to unauthenticatedRoute
    <>
      {onUnauthenticatedProvided ||
        window.location.replace(createUrl(unauthenticatedRoute))}
    </>
  )
}

const ProtectedRoute = ({ render, ...props }) => {
  return (
    <Route
      {...props}
      component={moreProps => (
        <Render {...props} {...moreProps} render={render} />
      )}
    />
  )
}

ProtectedRoute.propTypes = {
  allowed: arrayOf(string).isRequired,
  component: oneOfType([func, object]),
  onUnauthenticated: func,
  onUnauthorized: func,
  session: instanceOf(Session),
  unauthorizedRoute: string,
  unauthenticatedRoute: string,
  render: func,
}

ProtectedRoute.defaultProps = {
  allowed: [],
  unauthorizedRoute: ACCESS_DENIED,
  unauthenticatedRoute: ACCESS_DENIED,
  component: () => null,
}

export default ProtectedRoute
